<template>
  <div class="ListingAddCartBtn" :class="containerClass">
    <template v-if="icon">
      <a href="#" @click.prevent="addCart" :class="addCartIconClass">
        <i class="fal fa-cart-plus"></i>
      </a>
    </template>

    <template v-else>
      <a :href="checkoutPath" :class="viewCartBtn" v-if="item"> VIEW CART </a>
      <button @click.prevent="addCart" :class="addCartClass" v-else>ADD TO CART</button>
    </template>
  </div>
</template>

<script>
import gql from "graphql-tag"
import dataAddToCart from "@/lib/dataLayer/addToCart"
import CURRENT_QUERY from "@/queries/Current.query.gql"
import CART_ADD_ITEM_MUTATION from "@/queries/Cart/AddItem.mutation.gql"

import { trackListingAddCart as fbqTrackAddCart } from "@/lib/fbq"
import { actions } from "../Cart/navStore.js"

const ITEMS_QUERY = gql`
  {
    checkoutCart @client {
      items {
        id
        listingId
        frame: addon(key: "frame") {
          option
        }
      }
    }
  }
`
export default {
  name: "Listing.AddCartBtn",
  data: () => ({
    item: null,
  }),
  props: {
    icon: {
      type: Boolean,
      default: false,
    },
    listingId: {
      type: Number,
      required: true,
    },
    checkoutPath: {
      type: String,
      required: true,
    },
    containerClass: {
      type: String,
      default: "",
    },
    addCartClass: {
      type: String,
      default: "btn btn-default w-full",
    },
    viewCartClass: {
      type: String,
      default: null,
    },
    addCartIconClass: {
      type: String,
      default: "text-xl",
    },
    mode: {
      type: String,
      default: "regular",
    },
  },
  apollo: {
    item: {
      query: ITEMS_QUERY,
      manual: true,
      result({ data }) {
        if (data) {
          const {
            checkoutCart: { items },
          } = data
          this.item = items.find((i) => i.listingId == this.listingId)
        }
      },
    },
  },
  methods: {
    addCart() {
      this.mode == "modal" ? this.showModal() : this.addCartMutation()
    },
    showModal() {
      actions.setAvailability({ id: this.listingId, parentType: "group" })
    },
    addCartMutation() {
      this.$apollo.mutate({
        mutation: CART_ADD_ITEM_MUTATION,
        variables: {
          listingId: this.listingId,
          framing: "default",
        },
        update: (store, { data: { addCartItem } }) => {
          const query = CURRENT_QUERY
          const data = store.readQuery({ query })
          const { listing, cart } = addCartItem

          data.checkoutCart = cart
          dataAddToCart(listing)
          fbqTrackAddCart(listing)
          this.open()

          store.writeQuery({ query, data })
          actions.resetAvailability()
        },
      })
    },
    ...actions,
  },
  computed: {
    viewCartBtn() {
      return this.viewCartClass || this.addCartClass
    },
  },
}
</script>
